module.exports = __webpack_public_path__ + "static/media/icon_wrench.85524a94.svg";